const employees = {
  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },
  },

  edit: {
    tabs: {
      information: 'Information',
      history: 'Geschichte',
      bookingHistory: 'Buchungsverlauf',
    }
  },

  table: {
    headers: {
      createBtn: 'Erstellen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      homeAddress: 'Privatadresse',
      workAddress: 'Arbeitsadresse',
      createdAt: 'Erstellt am',
      createdBy: 'Erstellt von',
    },
  },
  form: {
    header: {
      create: {
        title: 'Erstellen',
      },

      update: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    actions: {
      header: 'Aktionen',
      buttons: {
        resetPassword: 'Passwort zurücksetzen',
      },
    },

    sections: {
      profiles: {
        header: 'Profil',
        fields: {
          profiles: {
            label: 'Profil',
          },
          attributes: {
            label: 'Eigenschaften'
          }
        },
      },
      personalDetails: {
        header: 'Persönliche Daten',
        fields: {
          firstName: {
            label: 'Vorname',
          },
          lastName: {
            label: 'Nachname',
          },
          email: {
            label: 'E-Mail',
          },
          phone: {
            label: 'Telefon',
          },
          additionalPhone: {
            label: 'Zusätzliches Telefon',
          },
        },
      },
      addresses: {
        header: 'Mitarbeiteradressen',
        fields: {
          workAddress: {
            label: 'Arbeitsadresse',
          },
          homeAddress: {
            label: 'Privatadresse',
          },
          additionalHomeAddress: {
            label: 'Privatadresse 2',
          },
        },
      },
    },
  },

  create: {
    confirmButtonText: 'Einreichen',
    toasts: {
      success: 'Mitarbeiter erfolgreich angelegt',
      error: 'Beim Erstellen des übergeordneten Elements ist ein Fehler aufgetreten',
    },
  },
  update: {
    activeStatus: {
      statusActive: 'Aktiv',
      statusDeactivate: 'Inaktiv',
    },

    suspend: {
      actionActivate: 'Aufheben der Sperre',
      actionDeactivate: 'Sperren',
      suspendModal: {
        popupTitleDeactivation: 'Fahrgast sperren',
        popupTitleActive: 'Grund für die Sperrung',
        popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
        popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
        popupActionActive: 'Fahrgastsperrung aufheben',
        popupActionDeactivate: 'Fahrgast sperren',
      },
    },
    toasts: {
      success: 'Übergeordnetes Element erfolgreich aktualisiert',
      error: 'Beim Aktualisieren des übergeordneten Elements ist ein Fehler aufgetreten',
      fetchError: 'please try again.,Etwas ist schiefgelaufen, bitte versuchen Sie es erneut., please try again.',
    },
  },
};

export default employees;
